module.exports = __webpack_public_path__ + "8cd6d743774c2e16578633c260d0a090.wasm";